import { render } from "./ModuleSearchDropdown.vue?vue&type=template&id=d135e774&scoped=true"
import script from "./ModuleSearchDropdown.vue?vue&type=script&lang=js"
export * from "./ModuleSearchDropdown.vue?vue&type=script&lang=js"

import "./ModuleSearchDropdown.vue?vue&type=style&index=0&id=d135e774&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d135e774"]])

export default __exports__